import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/inheritance-tax-calculator',
  component: () => import('../../routes/InheritanceTaxCalculator.svelte'),
  card: {
    id: 'inheritance-tax-calculator',
    title: 'Inheritance Tax Calculator',
    description: 'Estimate federal estate taxes and net inheritance after tax. Calculate what your beneficiaries receive after estate taxes.',
    icon: 'account_balance',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/inheritance-tax-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'Inheritance Tax Calculator – Federal Estate Tax Estimator',
    description: 'Free inheritance tax calculator. Estimate federal estate taxes, calculate your net inheritance after tax, and see how much your beneficiaries receive. Works for estates of any size.',
  },
};

export default meta;
